import React, { useState, useRef, useMemo } from 'react'
import Leaflet from 'leaflet'
import { EditControl } from 'react-leaflet-draw'

import {
  Map,
  Marker,
  TileLayer,
  CircleMarker,
  Popup,
  FeatureGroup,
  withLeaflet,
} from 'react-leaflet'

import '../../../node_modules/leaflet/dist/leaflet.css'
import '../../../node_modules/leaflet-draw/dist/leaflet.draw.css'
import marker from '../../assets/marker-icon.png'
import markerShaddow from '../../assets/marker-shadow.png'
import LeafletControlGeocoder from './LeafletControlGeocoder'

import { MapContainer, MapSingleContainer } from './styled'

delete Leaflet.Icon.Default.prototype._getIconUrl
Leaflet.Icon.Default.mergeOptions({
  iconRetinaUrl: marker,
  iconUrl: marker,
  shadowUrl: markerShaddow,
})

function DraggableMarker(props) {
  const markerRef = useRef(null)

  const eventHandlers = useMemo(
    () => ({
      dragend() {
        const marker = markerRef.current
        if (marker != null) {
          const latlng = marker.leafletElement.getLatLng()
          if (props.updateLatLon) {
            // Pass the latlng object to our handler, which will convert it properly
            props.updateLatLon(latlng)
          }
        }
      },
    }),
    [props.updateLatLon]
  )

  // Only render if we have a valid position
  if (!props.position || !Array.isArray(props.position)) {
    return null
  }

  return (
    <Marker
      draggable={true}
      onDragend={eventHandlers.dragend}
      position={props.position}
      ref={markerRef}
    />
  )
}

export default function SingleMap(props) {
  const [markerPosition, setMarkerPosition] = useState(
    props?.location
      ? [props?.location?.lat, props?.location?.lng]
      : [39.6549602, -8.5984025]
  )

  let mapProps = {
    zoom: 7,
    center: [39.6549602, -8.5984025],
  }

  // If props.location is provided, use it as initial position
  if (props.location && Array.isArray(props.location)) {
    mapProps.center = props.location
    if (
      !markerPosition ||
      (markerPosition[0] === 39.6549602 && markerPosition[1] === -8.5984025)
    ) {
      setMarkerPosition(props.location)
    }
  }
  // If props.center is provided (multiple locations), center on the first location
  else if (props.center && props.center.length > 0) {
    const validLocations = props.center.filter(
      (loc) => loc.center && Array.isArray(loc.center)
    )
    if (validLocations.length > 0) {
      // Use the first valid location as center
      mapProps.center = validLocations[0].center
      mapProps.zoom = 10 // Zoom out a bit to show multiple markers
    }
  }

  const handleLocationUpdate = (latlng) => {
    const newPosition = [latlng.lat, latlng.lng]
    setMarkerPosition(newPosition)

    // Call the parent callback if provided
    // Make sure to pass the format the parent expects
    if (props.updateLatLon) {
      // Check if parent expects array format or latlng object
      // Most likely it expects lat, lng as separate parameters
      props.updateLatLon(latlng.lat, latlng.lng)
    }
  }

  const handleSearchResult = (searchPosition) => {
    // Only update marker position, don't change map center/zoom
    // This allows users to see the marker and then drag it to customize
    setMarkerPosition(searchPosition)

    // Update props updateLatLon with correct format
    if (props.updateLatLon) {
      // searchPosition is already an array [lat, lng]
      props.updateLatLon(searchPosition[0], searchPosition[1])
    }
  }

  return (
    <MapSingleContainer>
      <MapContainer>
        <Map className={'map-container'} maxZoom={23} {...mapProps}>
          <TileLayer
            maxZoom={23}
            maxNativeZoom={18}
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {/* <SearchLayer updateLocation={props.updateLatLon} /> */}
          <LeafletControlGeocoder
            setPolygonData={handleSearchResult}
            // setAddress={props.setAddress}
          />

          {/** Single draggable marker */}
          {!props?.center && (
            <DraggableMarker
              position={markerPosition}
              updateLatLon={handleLocationUpdate}
            />
          )}
          {/* {props.updateLatLon && (
            <FeatureGroup>
              <EditControl
                key={`${new Date()}-elements`}
                position="topleft"
                onEdited={(e) => {
                  const layer = e.layers._layers
                  Object.keys(layer).map((layerI) => {
                    if (!layer[layerI]) return null
                    const centerM = layer[layerI]._latlng
                    //we need to update element view
                    props.updateLatLon(centerM.lat, centerM.lng)
                    return layerI
                  })
                }}
                onCreated={(e) => {
                  // const geoJson = e.layer.toGeoJSON();
                  // const center = geoJson.geometry.coordinates;
                  // console.log(center);
                  // props.updateLatLon(center[0], center[1]);
                  // Now we need to remove it
                  // it will be added from the db later
                  // const { edit } = refs;
                  // edit.context.layerContainer.removeLayer(e.layer._leaflet_id);
                }}
                edit={{
                  marker: true,
                  circle: false,
                  circlemarker: false,
                  rectangle: false,
                  polygon: false,
                  polyline: false,
                }}
                draw={{
                  marker: false,
                  circle: false,
                  circlemarker: false,
                  rectangle: false,
                  polygon: false,
                  polyline: false,
                }}
              />
              <Marker position={mapProps.center} />
            </FeatureGroup>
          )} */}

          {/* Other markers from props.center */}
          {props?.center?.map(
            (marker, i) =>
              marker.center && (
                <CircleMarker
                  key={i}
                  center={marker.center}
                  radius={10}
                  fillColor={marker.color || '#5fba7d'}
                  color={marker.color || '#5fba7d'}
                  weight={3}
                  opacity={1}
                  fillOpacity={0.5}
                  riseOnHover={true}
                  autoPan={true}
                  keepInView={true}
                  onClick={() => {
                    if (props.onClick) {
                      props.onClick(marker)
                    }
                  }}
                >
                  <Popup>
                    <h6>{marker.name}</h6>
                    <p
                      style={{ margin: 0, padding: 0 }}
                      dangerouslySetInnerHTML={{ __html: marker.description }}
                    />
                  </Popup>
                </CircleMarker>
              )
          )}
          {/** Red circle marker for searched location only when not draggable */}
          {/* {polygonData && props.updateLatLon === undefined && (
            <CircleMarker
              center={polygonData}
              radius={8}
              fillColor={'#ff0000'}
              color={'#ff0000'}
              weight={3}
              opacity={1}
              fillOpacity={0.7}
            >
              <Popup>
                <h6>Searched Location</h6>
                <p>
                  Lat: {polygonData[0].toFixed(6)}, Lng:{' '}
                  {polygonData[1].toFixed(6)}
                </p>
              </Popup>
            </CircleMarker>
          )} */}
        </Map>
      </MapContainer>
    </MapSingleContainer>
  )
}
